export const types = {
	CHANGE_LANGUAGE: 'CHANGE_LANGUAGE'
};

export const changeLanguage = (newLanguage, type) => {
	return (dispatch) => {
        dispatch({type: types[type], payload: newLanguage})
	};
};